import React, {useContext, useEffect, useRef, useState} from "react";
import { AuthContext } from "../context/AuthContext";
import { useHttp } from "../hooks/http.hook";
import {  withRouter } from "react-router-dom";
import Input from "../components/Input";
import ClientTypeSelector from "../components/ClientTypeSelector";
import UslugiSelector from "../components/UslugiSelector";
import { Document, ImageRun, Packer, Paragraph } from "docx";
import { saveAs } from "file-saver";
import { getDocModule } from "../data/doc-router";
import { CardContext } from "../context/CardContext";
import { HomeConfirm } from "../components/HomeConfirm";

const EditClientPage = ({ history }) => {
  const card = useContext(CardContext)
  const { setHomeConfirm, pendingTarget } = useContext(CardContext);
  const [showHomeConfirm, setShowHomeConfirm] = useState(false);
  const auth = useContext(AuthContext);
  const { request } = useHttp();
  const [link, setLink] = useState("");
  const usluga = {
    type: "1",
  };
  const [form, setform] = useState({
    date: "",
    clientType: {
      type: "",
      fio: "",
      otherDetails: "",

      ofp: "",
      fullofp: "",
      shortofp: "",

      name: "",
      shortname: "",
      inface: "",
      doljnost: "",
      actions: "",
      family: "",
      inn: "",
      ogrn: "",
    },
    phone: "",
    email: "",
    uslugi: [{ type: "" }],
    deadline: "",
    totalPrice: "",
    paymentMethod: "",
    vneseno:"",
    ostatok:"",
    thirdPersonPayment: false,
    thirdPersonDetails: '',
    details: "",
    urist: "",
    contacts: "",
    id:null,
    formed: false,
    isRegular: false
  });

  useEffect(() => {
    window.M.updateTextFields();
  }, [form]);

  useEffect(() => {
    if (card.cardForm){
      setform(card.cardForm);
    }
    else{
      setform({
        date: "",
        clientType: {
          type: "",
          fio: "",
          otherDetails: "",
  
          ofp: "",
          fullofp: "",
          shortofp: "",
  
          name: "",
          shortname: "",
          inface: "",
          doljnost: "",
          actions: "",
          family: "",
          inn: "",
          ogrn: "",
        },
        phone: "",
        email: "",
        uslugi: [{ type: "" }],
        deadline: "",
        totalPrice: "",
        paymentMethod: "",
        vneseno:"",
        ostatok:"",
        thirdPersonPayment: false,
        thirdPersonDetails: '',
        details: "",
        urist: "",
        contacts: "",
        _id:null,
        formed: false,
        isRegular: false
      });
    }
    
    window.M.updateTextFields();
  }, []);

  useEffect(() => {
    setHomeConfirm(() => () => setShowHomeConfirm(true))
    return () => setHomeConfirm(null)
  }, [setHomeConfirm])

  const leaveForm = () => {
    setShowHomeConfirm(false)
    if (pendingTarget === 'logout') {
      auth.logout()
      history.push('/')
    } else {
      history.push(pendingTarget || '/bases')
    }
  }

  const SaveCard = async (formed = form.formed, isGenerate) => {
        try {
            const data = await request('/api/card/generate', 'POST', {form:{...form, formed, details:form.email+form.phone}}, {
                Authorization: `Bearer ${auth.token}`
            })
            alert(data.message)
            if (isGenerate){
              getDocModule().GenerateDoc(form, data.formedId)
            }
        } catch (e) {
        }
  };

  const FormSchetAndAct = async (formed = form.formed, isGenerate) => {
    try {
      let data = await request('/api/card/generate', 'POST', {form:{...form, formed, details:form.email+form.phone}}, {
        Authorization: `Bearer ${auth.token}`
      })
      alert(data.message)
      data = await request('/api/card/schet', 'POST', {id: form._id}, {
        Authorization: `Bearer ${auth.token}`
      })
      alert(data.message)
      if (form._id){
        getDocModule().GenerateSchetAndAct(form, data.formedId, data.date, data.schetId)
      }
    } catch (e) {
    }
  };



  const SaveWithoutGenerateCard = async (formed = form.formed, isGenerate) => {
    try {
      const data = await request('/api/card/generate', 'POST', {form:{...form, formed, details:form.email+form.phone}}, {
        Authorization: `Bearer ${auth.token}`
      })
      alert(data.message)
    } catch (e) {
    }
  };

  const RestoreSchet = async () => {
    try {
      console.log(form._id)
      if (form._id !== null && form._id !== "") {
        console.log(1)
        const data = await request(`/api/card/${form._id}/restore`, 'GET', null,{
          Authorization: `Bearer ${auth.token}`
        })
        alert(data.message)
      }
    } catch (e) {
      console.log(e)
    }
  };

  const ToDate = (value) => {
    if (value !== ''){
      value = value.slice(6, 10) + "-" + value.slice(3, 5) + "-" + value.slice(0, 2)
    }
    return value
  }
  const SetValueDate = (field, value) => {
    if (value !== ''){
      value = value.slice(8, 10) + "." + value.slice(5, 7) + "." + value.slice(0, 4)
    }
    setform({ ...form, [field]: value });
  }

  const SetValue = (field, value) => {
    if (typeof value === "string") {
      let searchItem = null
      value = value.replaceAll('«', '"')
      value = value.replaceAll('»', '"')
      for (let i = 0; i < value.length; i++) {
        searchItem = value.indexOf('"')
        if (searchItem === -1) {
          break
        }
        if (searchItem + 1 !== value.length && value.charAt(searchItem+1)?.toLowerCase() !== value.charAt(searchItem+1)) {
          value = value.replace(/"/, '«')
        } else{
          value = value.replace(/"/, '»')
        }

      }
    }
    setform({ ...form, [field]: value });
  };

  const test = async () => {
    try {
      const data = await request('/api/card/test', 'GET', null, {
        Authorization: `Bearer ${auth.token}`
      })
      alert(data.message)
    } catch (e) {
    }
  }

  return (
    <div className="row">
      <div className="col s12" style={{ paddingTop: "2rem" }}>
        <Input
          id="date"
          type="date"
          caption="Дата"
          SetValue={SetValueDate}
          field="date"
          value={ToDate(form.date)}
        />
        <div className="divider"></div>
        <ClientTypeSelector SetValue={SetValue} value={form.clientType} />
        <div className="divider"></div>
        <Input
          id="phone"
          type="tel"
          caption="Телефон"
          SetValue={SetValue}
          field="phone"
          value={form.phone}
          placeholder="Введите номер телефона"
        />
        <div class="divider"></div>
        <Input
          id="email"
          type="email"
          caption="Email"
          SetValue={SetValue}
          field="email"
          value={form.email}
          placeholder="Введите Email"
        />
        <div className="divider"></div>
        <UslugiSelector value={form.uslugi} SetValue={SetValue} />
        <div className="divider"></div>
        <Input
          id="deadline"
          type="text"
          caption="Срок указания услуг"
          SetValue={SetValue}
          field="deadline"
          value={form.deadline}
          placeholder="Введите срок указания услуг"
        />
        <div className="divider"></div>
        <Input
          id="totalPrice"
          type="text"
          caption="Общая сумма договора"
          SetValue={SetValue}
          field="totalPrice"
          value={form.totalPrice}
          placeholder="Введите сумму"
        />
        <div className="input-field">
          <div>
            <label>Способ оплаты</label>
          </div>
          <select
            onChange={(e) => {
              SetValue("paymentMethod", e.target.value);
            }}
            className="browser-default"
          >
            <option
              value=""
              disabled
              selected={form.paymentMethod == "" ? true : false}
            >
              ...
            </option>
            <option
              value="Наличный расчет"
              selected={form.paymentMethod == "Наличный расчет" ? true : false}
            >
              Наличный расчет
            </option>
            <option
              value="Безналичный расчет"
              selected={
                form.paymentMethod == "Безналичный расчет" ? true : false
              }
            >
              Безналичный расчет
            </option>
          </select>
        </div>
        {form.paymentMethod !=='Наличный расчет' ? <div></div> : 
        <div>
        <Input
        id="vneseno"
        type="text"
        caption="Внесено"
        SetValue={SetValue}
        field="vneseno"
        value={form.vneseno}
        placeholder="Введите внесенную сумму"
        />
        <Input
        id="ostatok"
        type="text"
        caption="Остаток"
        SetValue={SetValue}
        field="ostatok"
        value={form.ostatok}
        placeholder="Введите остаток суммы"
        />
        </div> }
        <form action="#">
          <p>
            <label>
              <input
                onChange={() => {
                  SetValue("thirdPersonPayment", !form.thirdPersonPayment);
                }}
                type="checkbox"
                className="filled-in"
                checked={form.thirdPersonPayment}
              />
              <span>Оплата 3-м лицом</span>
            </label>
          </p>
        </form>
        {form.thirdPersonPayment ? <Input
          id="thirdPersonDetails"
          type="text"
          caption="Данные 3-го лица"
          SetValue={SetValue}
          field="thirdPersonDetails"
          value={form.thirdPersonDetails}
          placeholder="Введите данные 3-го лица"
        /> : <div></div>}
        <div className="divider"></div>
        {/* <Input
          id="details"
          type="text"
          caption="Данные заказчика"
          SetValue={SetValue}
          field="details"
          value={form.details}
          placeholder="Введите данные заказчика"
        /> */}
        <div className="divider"></div>
        <div className="input-field">
          <div>
            <label>Юрист</label>
          </div>
          <select
            onChange={(e) => {
              SetValue("urist", e.target.value);
            }}
            className="browser-default"
          >
            <option
              value=""
              disabled
              selected={form.urist == "" ? true : false}
            >
              ...
            </option>
            <option
              value="София"
              selected={form.urist == "София" ? true : false}
            >
              София
            </option>
            <option
              value="Наталья"
              selected={
                form.urist == "Наталья" ? true : false
              }
            >
              Наталья
            </option>
            <option
              value="Алина"
              selected={
                form.urist == "Алина" ? true : false
              }
            >
              Алина
            </option>
            <option
              value="Олеся"
              selected={
                form.urist == "Олеся" ? true : false
              }
            >
              Олеся
            </option>
          </select>
        </div>
        <form action="#">
          <p>
            <label>
              <input
                  onChange={() => {
                    SetValue("isRegular", !form.isRegular);
                  }}
                  type="checkbox"
                  className="filled-in"
                  checked={form.isRegular}
              />
              <span>Постоянный клиент</span>
            </label>
          </p>
        </form>
        <div className="divider"></div>
        <div className="row">
          <form className="col s12">
            <div className="row">
              <div className="input-field col s12">
                <textarea value={form.contacts} placeholder="Введите контактные данные" onChange={(e) => SetValue("contacts", e.target.value)} id="textarea1" className="materialize-textarea"></textarea>
                <label htmlFor="textarea1">Контактные данные</label>
              </div>
            </div>
          </form>
        </div>
        <div className="row">
          <div className="col s12 m4 l4">
          <a className="waves-effect waves-light btn-small" onClick={() => {
            RestoreSchet()
          }}>Восстановить счет</a>
            </div>
        </div>
        {/* <div className="row"> */}
          <div className="col s12 m5 l5"></div>
          {/* <div className="col s12 m4 l2">
            <a className="waves-effect waves-light btn-large" onClick={() => {SaveCard(form.formed, false)}}>Сохранить</a>
          </div> */}
          <div className="row">
            <div className="col s12 m4 l2">
              <a className="waves-effect waves-light btn-large" onClick={() => {
                SaveCard(true, true)
              }}>Сформировать</a>
            </div>
          </div>
        <div className="row">
        <div className="col s12 m4 l4">
          <a className="waves-effect waves-light btn-large" onClick={() => {
            SaveWithoutGenerateCard(false, false)}}>Сохранить</a>
        </div>
        </div>
        <div className="row">
        {form.isRegular && form.paymentMethod === 'Безналичный расчет' && <div className="col s12 m4 l4">
          <a className="waves-effect waves-light btn-large" onClick={() => {
            FormSchetAndAct(true, true)}}>Сформировать только счет и акт</a>
        </div>}
        </div>
          <div className="col s12 m4 l4">

          </div>
        {/* </div> */}
      </div>
      <HomeConfirm
        open={showHomeConfirm}
        onSave={() => { SaveCard(form.formed, false); leaveForm() }}
        onExit={leaveForm}
      />
    </div>
  );
};

export default withRouter(EditClientPage);